import React, { useState, useRef, useEffect, useMemo } from "react";
import { nanoid } from "nanoid";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./NotificationInput.module.css";
import { ReactComponent as DownArrow } from "../../assets/Down_Arrow.svg";
import CloseButton from "./Close_Button.svg";
/**
 * Interactive component. Custom select box.
 */
export function NotificationInput({
  _id,
  name,
  email,
  editMode = false,
  onChange,
  onDelete,
}) {
  const [nameValue, setName] = useState(name);
  const [emailValue, setEmail] = useState(email);
  useEffect(() => {
    if (name) setName(name);
    if (email) setEmail(email);
  }, [name, email]);
  const handleChange = (v, type) => {
    if (type === "name") setName(v);
    else setEmail(v);
    const payload = {
      _id: _id || null,
      name: type === "name" ? v : nameValue,
      email: type !== "name" ? v : emailValue,
    };
    onChange(payload);
  };
  return (
    <div className={classNames(styles.container)}>
      <input
        className={classNames(styles["input"])}
        type="text"
        name="name"
        value={nameValue}
        onChange={(e) => handleChange(e.target.value, "name")}
        readOnly={!editMode}
      />
      <input
        className={classNames(styles["input"])}
        type="text"
        name="email"
        value={emailValue}
        onChange={(e) => handleChange(e.target.value, "email")}
        readOnly={!editMode}
      />
      <div className={classNames(styles["line"])}></div>
      {editMode && (
        <button
          onClick={onDelete}
          className={classNames(styles["delete-button"])}
        >
          <img src={CloseButton} alt="" />
        </button>
      )}
    </div>
  );
}

NotificationInput.propTypes = {};
